import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {AttachmentsViewModalComponent} from './attachments-view-modal.component';

@Injectable({
    providedIn: 'root'
})
export class AttachmentsViewModalService extends ModalService {
    showModal(url: string, fileName: string, type: string) {
        this.createModalComponent(AttachmentsViewModalComponent);
        const attachmentsModalComponentInstance = this.modalComponentRef.instance as AttachmentsViewModalComponent;
        attachmentsModalComponentInstance.url = url;
        attachmentsModalComponentInstance.title = fileName;
        attachmentsModalComponentInstance.type = type;
        this.showModalComponent();
        return attachmentsModalComponentInstance.modalClosed;
    }
}
